<template>
  <div>
    <el-dialog :width="Diawidth" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose"
      :close-on-click-modal="true" :show-close="true" :close-on-press-escape="true">
      <span slot='title' class="el-dialog__title">pdf浏览</span>
      <iframe :src="pdfurl" frameborder="0" style="width: 100%; height: 100%"></iframe>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: ["pdfurl"],
    data() {
      return {
        dialogVisible: true,
        Diawidth: "60%",
      }
    },
    mounted() {
      console.log(this.pdfurl)
    },
    methods: {
      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },

      cancel() { //取消
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },
    }
  }
</script>

<style scoped>
  >>>.el-dialog {
    height: 740px;
    background: url(../../common/images/dialog.png) no-repeat center;
    background-size: 100% 100%;
  }

  >>>.el-dialog__body {
    height: 650px;
    padding-top: 0;
  }

  >>>.el-dialog__header {
    /* border: none; */
    padding-left: 0;
    margin: 10px 20px 8px 20px;
  }

  >>>.el-dialog__body, .el-dialog__footer{
      background: transparent;
  }
</style>
